import _styled from "@emotion/styled-base";

var SVG = _styled("svg", {
  target: "e1cfd24a0",
  label: "SVG"
})("fill:", function (_ref) {
  var fill = _ref.fill,
      theme = _ref.theme;
  return fill ? fill : theme.colors.white;
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdmdzL1NWRy5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRXNCIiwiZmlsZSI6Ii4uLy4uL3NyYy9zdmdzL1NWRy5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuY29uc3QgU1ZHID0gc3R5bGVkLnN2Z2Bcblx0ZmlsbDogJHsoeyBmaWxsLCB0aGVtZSB9KSA9PiAoZmlsbCA/IGZpbGwgOiB0aGVtZS5jb2xvcnMud2hpdGUpfTtcbmBcbmV4cG9ydCBkZWZhdWx0IFNWR1xuIl19 */"));

export default SVG;